module.exports = __webpack_public_path__ + "static/media/icons.0ab54153.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff2
// module id = 403
// module chunks = 0